import Loading from './Loading'

export default Loading



// WEBPACK FOOTER //
// ./src/legacy/components/Loading/index.js